<template>
  <div>
    <div :class="$style.modalContext">
      {{ $t('vendorsPage.vendorInfoComponent.info') }}
    </div>
    <MCAVendorFieldset>
      <UiInput
        ref="vendorLabelInput"
        name="label"
        type="text"
        :error-msg="$t('common.errors.mandatory')"
        :label="$t('common.nickname')"
        :value="info.label"
        required
        @input="setVendorProps"
      />
      <UiDropdown
        ref="vendorCategoryInput"
        :external-label="$t('vendorsPage.vendorInfoComponent.vendorCategory')"
        name="vendorCategory"
        :error-msg="$t('common.errors.mandatory')"
        :label="$t('common.selectCategory')"
        data-cy="vendor-category"
        :options="vendorCategories"
        :value="info.vendorCategory"
        size="small"
        required
        @input="setVendorProps"
      />
      <UiInput
        ref="vendorWebsiteInput"
        name="website"
        type="text"
        :error-msg="$t('common.errors.mandatory')"
        :label="$t('common.website')"
        :value="info.website"
        @input="setVendorProps"
      />
    </MCAVendorFieldset>
    <MCAVendorFieldset>
      <UiInput
        ref="vendorReasonInput"
        :external-label="$t('vendorsPage.vendorInfoComponent.reasonForPayment')"
        name="reason"
        type="text"
        :error-msg="$t('common.errors.mandatory')"
        :label="$t('vendorsPage.vendorInfoComponent.reasonForPayment')"
        :value="info.reason"
        @input="setVendorProps"
      />
    </MCAVendorFieldset>
    <MCAVendorFieldset>
      <UiInput
        ref="vendorNameInput"
        name="vendorName"
        type="text"
        :error-msg="$t('common.errors.mandatory')"
        :label="$t('common.contactName')"
        :value="info.vendorName"
        required
        @input="setVendorProps"
      />
      <UiInput
        ref="vendorEmailInput"
        name="vendorEmail"
        type="email"
        :error-msg="$t('common.errors.mandatory')"
        :label="$t('common.contactEmail')"
        :value="info.vendorEmail"
        :required="!info.vendorPhone"
        @input="setVendorProps"
      />
      <UiInput
        ref="vendorPhoneInput"
        type="number"
        name="vendorPhone"
        :error-msg="$t('common.errors.mandatory')"
        :label="$t('common.contactPhone')"
        :value="info.vendorPhone"
        :required="!info.vendorEmail"
        @input="setVendorProps"
      />
    </MCAVendorFieldset>
    <UiButton
      :text="$t('common.buttons.next')"
      data-cy="next-button"
      @click="handleNext"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { UiDropdown, UiButton, UiInput } from 'ui-components';
import {
  VENDOR_CATEGORIES,
  INDIEGOGO_VENDOR_CATEGORIES,
} from '@/data/vendor-categories';
import MCAVendorFieldset from './MCAVendorFieldset.vue';
export default {
  components: {
    UiButton,
    UiInput,
    UiDropdown,
    MCAVendorFieldset,
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.info = {
      label: this.selectedVendor.label,
      vendorCategory: this.selectedVendor.vendorCategory,
      website: this.selectedVendor.details.website,
      reason: this.selectedVendor.details.reason,
      vendorName: this.selectedVendor.details.vendorName,
      vendorEmail: this.selectedVendor.details.vendorEmail,
      vendorPhone: this.selectedVendor.details.vendorPhone,
    };
  },
  computed: {
    ...mapGetters(['selectedVendor', 'activeAdvances']),
    hasActiveIndiegogoAdvance() {
      return (
        this.activeAdvances.length === 1 &&
        [this.activeAdvances[0].feesVersionId].includes(9)
      );
    },
    vendorCategories() {
      const categoryOptions = this.hasActiveIndiegogoAdvance
        ? INDIEGOGO_VENDOR_CATEGORIES
        : VENDOR_CATEGORIES;
      return Object.entries(categoryOptions).map((v, i) => {
        return {
          key: i,
          value: v[0],
          name: v[1],
        };
      });
    },
  },
  methods: {
    setVendorProps(val, name) {
      if (name) {
        this.info[name] = val;
      }
    },
    async handleNext(event) {
      if (!event) return;

      const inputs = [
        this.$refs.vendorLabelInput,
        this.$refs.vendorCategoryInput,
        this.$refs.vendorWebsiteInput,
        this.$refs.vendorReasonInput,
        this.$refs.vendorNameInput,
        this.$refs.vendorEmailInput,
        this.$refs.vendorPhoneInput,
      ].filter((input) => input);

      inputs.forEach((field) => field.$touch());
      const isValid = inputs.every((field) => field.isValid);
      if (isValid) {
        const { label, vendorCategory, ...details } = this.info;
        const infoData = {
          label,
          vendorCategory,
          details,
        };
        this.$emit('next-tab', infoData);
      }
    },
  },
};
</script>
<style lang="less" module>
.modalContext {
  color: black;
  padding-bottom: 30px;
  text-align: center;
  font-weight: bold;
}
</style>
